export const missingSkills = [
    {
        "slug": "adobe-after-effects",
        "name": "Adobe After Effects",
        "icon": "adobeaftereffects"
    },
    {
        "slug": "adobe-illustrator",
        "name": "Adobe Illustrator",
        "icon": "adobeillustrator"
    },
    {
        "slug": "adobe-indesign",
        "name": "Adobe InDesign",
        "icon": "adobeindesign"
    },
    {
        "slug": "adobe-xd",
        "name": "Adobe XD",
        "icon": "adobexd"
    },
    {
        "slug": "amazon-api-gateway",
        "name": "Amazon API Gateway",
        "icon": "amazonapigateway"
    },
    {
        "slug": "rest-api",
        "name": "REST API",
        "icon": "amazonapigateway"
    },
    {
        "slug": "amazon-dynamodb",
        "name": "Amazon DynamoDB",
        "icon": "amazondynamodb"
    },
    {
        "slug": "dynamodb-aws",
        "name": "DynamoDB (AWS)",
        "icon": "amazondynamodb"
    },
    {
        "slug": "amazon-ec2",
        "name": "Amazon EC2",
        "icon": "amazonec2"
    },
    {
        "slug": "amazon-ecs",
        "name": "Amazon ECS",
        "icon": "amazonecs"
    },
    {
        "slug": "amazon-eks",
        "name": "Amazon EKS",
        "icon": "amazoneks"
    },
    {
        "slug": "amazon-rds",
        "name": "Amazon RDS",
        "icon": "amazonrds"
    },
    {
        "slug": "amazon-redshift",
        "name": "Amazon Redshift",
        "icon": "amazonredshift"
    },
    {
        "slug": "redshift-aws",
        "name": "Redshift (AWS)",
        "icon": "amazonredshift"
    },
    {
        "slug": "amazon-s3",
        "name": "Amazon S3",
        "icon": "amazons3"
    },
    {
        "slug": "amazon-sqs",
        "name": "Amazon SQS",
        "icon": "amazonsqs"
    },
    {
        "slug": "angular-1-angularjs",
        "name": "Angular 1 (AngularJS)",
        "icon": "angularjs"
    },
    {
        "slug": "azure-synapse",
        "name": "Azure Synapse",
        "icon": "microsoftazure"
    },
    {
        "slug": "microsoft-azure-cdn",
        "name": "Microsoft Azure CDN",
        "icon": "microsoftazure"
    },
    {
        "slug": "azure",
        "name": "Azure",
        "icon": "microsoftazure"
    },
    {
        "slug": "azure-data-factory",
        "name": "Azure Data Factory",
        "icon": "azuredataexplorer"
    },
    {
        "slug": "azure-devops",
        "name": "Azure DevOps",
        "icon": "azuredevops"
    },
    {
        "slug": "azure-function",
        "name": "Azure Function",
        "icon": "azurefunctions"
    },
    {
        "slug": "photoshop",
        "name": "Adobe Photoshop",
        "icon": "adobephotoshop"
    },
    {
        "slug": "amazon-cloudwatch",
        "name": "Amazon CloudWatch",
        "icon": "amazoncloudwatch"
    },
    {
        "slug": "aws",
        "name": "Amazon Web Services",
        "icon": "amazonaws"
    },
    {
        "slug": "amazon-quicksight",
        "name": "Amazon QuickSight",
        "icon": "amazonaws"
    },
    {
        "slug": "d3js",
        "name": "D3.js",
        "icon": "d3dotjs"
    },
    {
        "slug": "data-scraping",
        "name": "Data Scraping",
        "icon": "datacrawling"
    },
    {
        "slug": "css",
        "name": "CSS",
        "icon": "CSS3"
    },
    {
        "slug": "hyperledger",
        "name": "Hyperledger",
        "icon": "hyperledger"
    },
    {
        "slug": "hyperledger-fabric",
        "name": "Hyperledger Fabric",
        "icon": "hyperledger"
    },
    {
        "slug": "identity-and-access-management",
        "name": "Identity and Access Management",
        "icon": "amazoniam"
    },
    {
        "slug": "justinmind",
        "name": "Justinmind",
        "icon": "justinmind"
    },
    {
        "slug": "lambda",
        "name": "Lambda",
        "icon": "awslambda"
    },
    {
        "slug": "linux-shell-script",
        "name": "Linux Shell Script",
        "icon": "windowsterminal"
    },
    {
        "slug": "unix",
        "name": "UNIX",
        "icon": "windowsterminal"
    },
    {
        "slug": "window-server",
        "name": "Window Server",
        "icon": "windowsterminal"
    },
    {
        "slug": "magento",
        "name": "Magento",
        "icon": "magento"
    },
    {
        "slug": "microsoft-edge",
        "name": "Microsoft Edge",
        "icon": "microsoftedge"
    },
    {
        "slug": "microsoft-office-suite",
        "name": "Microsoft Office Suite",
        "icon": "microsoftoffice"
    },
    {
        "slug": "microsoft-sharepoint",
        "name": "Microsoft SharePoint",
        "icon": "microsoftsharepoint"
    },
    {
        "slug": "nuxtjs",
        "name": "NuxtJS",
        "icon": "nuxtdotjs"
    },
    {
        "slug": "optimizely",
        "name": "Optimizely",
        "icon": "optimizely"
    },
    {
        "slug": "powerpoint",
        "name": "Powerpoint",
        "icon": "microsoftpowerpoint"
    },
    {
        "slug": "powershell",
        "name": "Powershell",
        "icon": "Powershell"
    },
    {
        "slug": "resque",
        "name": "Resque",
        "icon": "resque"
    },
    {
        "slug": "soql",
        "name": "SOQL",
        "icon": "soql"
    },
    {
        "slug": "strategic-thinking",
        "name": "Strategic Thinking",
        "icon": "strategicthinking"
    },
    {
        "slug": "testcaselab",
        "name": "TestCaseLab",
        "icon": "testcaselab"
    },
    {
        "slug": "visual-basic",
        "name": "Visual Basic",
        "icon": "visualbasic"
    },
    {
        "slug": "web-crawling",
        "name": "Web Crawling",
        "icon": "webcrawling"
    },
    {
        "slug": "microsoft-power-bi",
        "name": "Microsoft Power BI",
        "icon": "powerbi"
    },
    {
        "slug": "xamarin",
        "name": "Xamarin",
        "icon": "xamarin"
    },
    {
        "slug": "tableau",
        "name": "Tableau",
        "icon": "tableau"
    },
    {
        "slug": "c-hash",
        "name": "C#",
        "icon": "csharp"
    },
    {
        "slug": "oracle-db",
        "name": "Oracle DB",
        "icon": "oracle"
    },
    {
        "slug": "visual-studio-code",
        "name": "Visual Studio Code",
        "icon": "visualstudiocode"
    },
    {
        "slug": "classic-asp",
        "name": "Classic ASP",
        "icon": "microsoft"
    },
    {
        "slug": "xamarin",
        "name": "Xamarin",
        "icon": "xamarin"
    }
];
